import type {
	ModuleFull,
	WaterbodiesResponse,
} from "@features/modules/waterbodies/types";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";

const includedPropList = [
	"id",
	"area",
	"waterbody_type",
	"trophic_type_start",
	"trophic_type_w",
	"trophic_type_wo",
	"land_use_change",
	"note",
	"trophic_type_thread",
];
const includedT2PropList = [
	"soc_t2_start",
	"soc_t2_w",
	"soc_t2_wo",
	"ch4_ef_t2_start",
	"ch4_ef_t2_w",
	"ch4_ef_t2_wo",
	"alpha_t2_start",
	"alpha_t2_w",
	"alpha_t2_wo",
	"mean_annual_t2_start",
	"mean_annual_t2_w",
	"mean_annual_t2_wo",
];

// Define constants for the module
const MODULE_TYPE = "Waterbodies";
const TAG: TagTypes = "Waterbodies";
const TAG_DEFAULTS: TagTypes = "WaterbodiesDefaults";
const ENDPOINT = FEModulesObj[FEModules.Waterbodies].path;

const transformResponse = (response: WaterbodiesResponse) => transformModuleResponse<WaterbodiesResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList
})

const waterbodiesApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicWaterbodiesApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const transformUpdatePayload = (data: Partial<ModuleFull>, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, WaterbodiesResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
	includesLandUseChange: true
})

export const {
	useGetWaterbodiesQuery,
	useGetWaterbodiesDefaultsQuery
} = waterbodiesApiSlice;

export const {
	useGetWaterbodiesQuery: usePublicGetWaterbodiesQuery,
	useGetWaterbodiesDefaultsQuery: usePublicGetWaterbodiesDefaultsQuery
} = publicWaterbodiesApiSlice;

export const {
	useUpdateWaterbodiesMutation,
} = mutationApiSlice;

export const waterbodiesEndpoints = waterbodiesApiSlice.endpoints;
export const waterbodiesMutationEndpoints = mutationApiSlice.endpoints;
